import { FC } from 'react';
import { Grid } from '@mui/material';
import StudentAssessmentsGrid from './studentAssessmentsGrid.view';
import AddEditAssessmentModal from './addEditAssessmentModal';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';
import { RbacDeniedRedirect } from '../../../../../components/rbac/RbacDeniedRedirect';

const StudentAssessmentsView: FC = () => {
  return (
    <PermissionGate
      module="students"
      submodule="scores"
      permission="read"
      fallback={<RbacDeniedRedirect />}
    >
      <Grid
        container
        spacing={2}
        sx={{ height: '100%' }}
        data-testid="student-assessments-container"
      >
        <Grid item xs={12}>
          <StudentAssessmentsGrid />
        </Grid>
      </Grid>
      <AddEditAssessmentModal />
    </PermissionGate>
  );
};

export default StudentAssessmentsView;
